export const environment = {
  "production": true,
  "authCookieName":  "estimator_zitadel_access_token",
  "API_ROOT": "https://api.estimator.flyevo.com/api/",
  "sentryEnvName": "prod-frontend",
  "sentryDSN": "https://9d39586c5f6e6f9ecece81263848790e@sentryv2.zitemedia.com/17",
  "zitadelUrl": "https://sso.flyevo.com",
  "zitadelUrlEndSession": "https://estimator.flyevo.com/login",
  "zitadelClientId": "340130133908195843",
  "zitadelRedirectUri": "https://estimator.flyevo.com/login",
  "plausibleDomain": "estomator.flyevo.com",
  "plausibleEndpoint": "https://plausible.zitemedia.com/api/event",
  "estimatorOrigin": "https://estimator.flyevo.com",
  "briefingsOrigin": "https://briefings.flyevo.com",
  "plausibleDomainBriefings": "briefings.flyevo.com"
};
